import { Paper } from "@mui/material";
import styled from "styled-components";

export const Container = styled(Paper)`
  padding: 20px;
`;

export const ScrollContainer = styled.div`
  overflow-y: scroll;
  height: 70vh;
  margin-bottom: 20px;
  padding-bottom: 10px;
  padding-right: 20px;
  padding-right: 20px;
`;
